import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import DriveInit from '../components/drive-init/index.vue';
import Init from '../components/drive-init/init.vue';
import AccessPermission from '../components/access-permission-explorer/Home.vue';
import ShowAccessPermission from '../components/access-permission-explorer/ShowAccessPermission.vue';
import ShowNotification from '../components/notification/ShowNotification.vue';
import ConfigureNotification from '../components/notification/ConfigureNotification.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/drive-init',
    name: 'drive-init',
    component: DriveInit,
  },
  {
    path: '/init',
    name: 'init',
    component: Init,
  },
  {
    path: '/access-permission',
    name: 'access-permission',
    component: AccessPermission,
    props: (route) => ({
      path: route.params.path,
      indexesHistoryProps: route.params.indexesHistoryProps,
    }),
  },
  {
    path: '/show-notification',
    name: 'show-notification',
    component: ShowNotification,
  },
  {
    path: '/configure-notification/:id',
    name: 'configure-notification',
    component: ConfigureNotification,
    props: (route) => ({
      id: route.params.id,
    }),
  },
  {
    path: '/show-access-permission',
    name: 'show-access-permission',
    component: ShowAccessPermission,
    props: (route) => ({
      item: route.params.item,
      indexesHistoryProps: route.params.indexesHistoryProps,
    }),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
